import $ from "jquery";

$(document).ready(function () {

  $('.banner').each(function () {
    var $banner = $(this);
    var mode = $banner.data('bannerMode');
    var delay = $banner.data('bannerDelay');

    var list = $banner.get(0);
    for (var i = list.children.length; i >= 0; i--) {
      list.appendChild(list.children[Math.random() * i | 0]);
    }
    $banner.find('.banner-item').each(function () {
      var list = this;
      for (var i = list.children.length; i >= 0; i--) {
        list.appendChild(list.children[Math.random() * i | 0]);
      }
    })

    $banner.find('.single-banner').each(function(){
      var $this = $(this);
      var id = $this.data('id');

      var element = $this.find('img,video,iframe');
      if (element && id) {
        element.each(function () {
          var elementSrc = $(this).data('src');
          if (elementSrc) {
            var src = new URL(elementSrc);
            src.searchParams.append('viewBanner', id);
            $(this).attr('src', src.toString());
          }
        });
      }

    });

    $banner.find('.banner-item').removeClass('hidden');

    $banner.imagesLoaded(function () {
      $.fn.matchHeight._update();
    });

    $banner.owlCarousel({
      items: 3,
      loop: mode,
      center: true,
      dots: false,
      autoplay: mode,
      autoplayTimeout: delay,
      responsive: {
        0:{
          items: 1,
        },
        480: {
          items: 2,
        },
        768:{
          items: 3,
        }
      }
    });
  });

});
